var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ec1b2e",
    d: "M.3 0h53.4v40H.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.2 8.6c-6.6-.4-9.6 8.2-3.4 11.4-2.2-1.8-1.7-4.6-.8-6h.1c-1.1 2-1 4.5 1 6-1.1-1-.8-3.2 1-4 1.8-.9 2-3.3 1.3-4.2q-1.2-2.1.8-3.2m-3.2 5-.4.7-.1-.7-.8-.2.7-.4v-.7l.5.5.7-.3-.3.7.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.4 19.4c-1.7-6.5-10.8-6.7-12 .3 1.2-2.7 3.9-3 5.5-2.7v.2c-2.2-.5-4.5.4-5.4 2.7.7-1.3 2.9-1.8 4.2-.3 1.4 1.4 3.8.8 4.4 0q1.6-1.8 3.3-.2m-5.8-1.5-.8-.2.7-.4v-.7l.5.5.7-.3-.3.7.4.6-.7-.1-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31 31.4c5.6-3.5 3-12.3-4-11.2 2.8.2 4 2.7 4.2 4.4H31a4.5 4.5 0 0 0-4.2-4.3c1.5.2 2.6 2.2 1.6 4-1 1.6.3 3.7 1.3 4q2.3 1 1.3 3.1m-.4-6v-.7l.5.5.7-.3-.3.7.4.6-.7-.1-.4.6-.2-.7-.7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.2 28.1c5.1 4.2 12.7-1 9.5-7.3a5 5 0 0 1-2.9 5.4v-.1c2-1 3.3-3 2.7-5.4.2 1.5-1.3 3.1-3.2 2.7S19.7 25 19.8 26q-.2 2.5-2.6 2.2m5.6-2.2.7-.3-.3.7.4.6-.7-.1-.4.6-.1-.7-.8-.2.7-.4v-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.1 14c-2.4 6.2 4.9 11.7 9.8 6.8-2.4 1.4-4.9.2-6-1.1l.2-.1a4.6 4.6 0 0 0 5.9 1c-1.3.6-3.3-.3-3.6-2.3-.2-2-2.5-2.9-3.4-2.6q-2.4.6-2.9-1.7m3.9 4.6.4.6-.7-.1-.4.6-.2-.7-.7-.2.7-.4v-.7l.5.5.7-.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/hk.aebd4a3b755cc184ff8c7ea0f2d86862.svg";
export { ForwardRef as ReactComponent };